export default __webpack_public_path__ + "static/media/relationships-256x256.34191051.png";